import React from 'react';

// DL.5 - Πόρισμα εξέτασης
const DL5 = ({ formData, updateFormData }) => {
  const examTypes = [
    'Ακτινογραφία',
    'Αξονική',
    'Μαγνητική',
    'Υπέρηχο',
    'Εγκεφαλογράφημα',
    'Ηλεκτρομυογράφημα (ΗΜΓ)',
    'Στεφανιογραφία',
    'Εξέταση επεμβατικής ακτινολογίας',
    'Βιοψία',
    'Κολονοσκόπηση',
    'Γαστροσκόπηση',
    'Ιστολογική'
  ];

  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  const handleAMKAChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 11) {
      updateFormData({ patientAmka: value });
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 15) {
      updateFormData({ phone: value });
    }
  };

  const handleExamTypeToggle = (examType) => {
    const currentTypes = formData.examTypes || [];
    const newTypes = currentTypes.includes(examType)
      ? currentTypes.filter(t => t !== examType)
      : [...currentTypes, examType];
    
    // Καθαρίζουμε την ημερομηνία αν αποεπιλέγεται ο τύπος
    const examDates = formData.examDates || {};
    if (!newTypes.includes(examType)) {
      delete examDates[examType];
    }
    
    updateFormData({ 
      examTypes: newTypes,
      examDates: examDates
    });
  };

  const handleExamDateChange = (examType, dateValue) => {
    const examDates = formData.examDates || {};
    examDates[examType] = dateValue;
    updateFormData({ examDates: examDates });
  };

  const validateAMKA = (amka) => {
    return /^\d{11}$/.test(amka);
  };

  return (
    <div>
      <div className="alert alert-info" style={{ marginBottom: '20px' }}>
        <p style={{ margin: 0 }}>
          <strong>Οδηγία:</strong> Παρακαλούμε επιλέξτε από τη λίστα (δυνατότητα πολλαπλής επιλογής):
        </p>
      </div>

      <div className="form-group">
        <label>
          Τύπος εξέτασης <span className="required">*</span>
        </label>
        <small style={{ color: '#666', display: 'block', marginBottom: '10px' }}>
          Μπορείτε να επιλέξετε περισσότερα από ένα
        </small>
        <div className="radio-container" style={{ marginTop: '10px', maxHeight: '300px', overflowY: 'auto' }}>
          {examTypes.map((type, index) => (
            <div key={type} style={{ 
              marginBottom: index === examTypes.length - 1 ? '0' : '10px',
              padding: '10px',
              border: `2px solid ${(formData.examTypes || []).includes(type) ? '#3498db' : '#e0e0e0'}`,
              borderRadius: '8px',
              transition: 'all 0.3s ease',
              maxWidth: '600px',
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'flex-start', 
                cursor: 'pointer',
                marginBottom: (formData.examTypes || []).includes(type) ? '8px' : '0',
              }}>
                <input
                  type="checkbox"
                  checked={(formData.examTypes || []).includes(type)}
                  onChange={() => handleExamTypeToggle(type)}
                  style={{ marginRight: '8px', marginTop: '3px', maxWidth: '30px'}}
                />
                <div style={{ flex: 1 }}>
                  {type}
                </div>
              </label>
              {(formData.examTypes || []).includes(type) && (
                <div style={{ marginLeft: '38px', marginTop: '8px' }}>
                  <input
                    type="text"
                    placeholder="Ημερομηνία/Περίοδος εξέτασης (π.χ. 01/01/2024 ή Ιανουάριος 2024)"
                    value={(formData.examDates && formData.examDates[type]) || ''}
                    onChange={(e) => handleExamDateChange(type, e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      fontSize: '14px'
                    }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="patientAmka">
          ΑΜΚΑ ασθενή <span className="required">*</span>
        </label>
        <input
          type="text"
          id="patientAmka"
          name="patientAmka"
          value={formData.patientAmka || ''}
          onChange={handleAMKAChange}
          placeholder="12345678901"
          maxLength="11"
          required
        />
        {formData.patientAmka && !validateAMKA(formData.patientAmka) && (
          <small style={{ color: '#e74c3c', display: 'block', marginTop: '5px' }}>
            Το AMKA πρέπει να είναι ακριβώς 11 ψηφία
          </small>
        )}
      </div>


      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">
            Email <span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email || ''}
            onChange={handleChange}
            placeholder="example@email.com"
            required
          />
          <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
            Το ίδιο με αυτό που δηλώσατε στην ΥΔ ή Εξουσιοδότηση
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="phone">
            Τηλ. Επικοινωνίας <span className="required">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone || ''}
            onChange={handlePhoneChange}
            placeholder="2101234567"
            inputMode="numeric"
            pattern="\d{10,15}"
            title="Εισάγετε μόνο αριθμούς (10-15 ψηφία)"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default DL5;








